// 日本語
export default {
  translation: {
    app_name: 'Agora',
    tagline: '趣味でつながるコミュニティ',
    nav_explore: '探す',
    nav_find_folks: '仲間を探す',
    nav_sign_in: 'ログイン',
    nav_join_free: '無料登録',
    nav_sign_out: 'ログアウト',
    nav_my_profile: 'マイプロフィール',
    nav_notifications: '通知',
    auth_register: 'アカウントを作成',
    auth_login: 'ログイン',
    auth_name: '氏名',
    auth_email: 'メールアドレス',
    auth_password: 'パスワード',
    auth_age: '年齢',
    auth_city: '市区町村',
    auth_building: 'マンション名 / 建物名',
    auth_country: '国',
    auth_currency: '通貨',
    auth_locale: '言語と地域',
    auth_already_have_account: 'すでにアカウントをお持ちですか？',
    auth_no_account: 'アカウントをお持ちでないですか？',
    postcode_label: '郵便番号',
    postcode_placeholder: '例）100-0001',
    profile_edit: 'プロフィール編集',
    profile_bio: '自己紹介',
    profile_interests: '趣味・関心',
    profile_location: '所在地',
    profile_theme: 'テーマ',
    profile_currency_settings: '通貨と地域',
    profile_save: '変更を保存',
    profile_cancel: 'キャンセル',
    group_join: 'グループに参加',
    group_leave: 'グループを退出',
    group_members: 'メンバー',
    group_chat: 'チャット',
    group_events: 'イベント',
    group_shop: 'ショップ',
    group_campaigns: 'キャンペーン',
    group_about: '詳細',
    group_full: '満員',
    group_open: '参加可能',
    tip_send: 'チップを送る',
    tip_amount: '金額',
    tip_message: 'メッセージ（任意）',
    wallet_coins: 'コイン',
    wallet_balance: '残高',
    tips_earned: '獲得済み',
    event_register: '参加登録',
    event_unregister: '登録をキャンセル',
    event_ticket_price: 'チケット',
    event_free: '無料',
    event_capacity: '定員',
    event_registered: '登録済み',
    no_results: '結果が見つかりません',
    loading: '読み込み中…',
    error_generic: 'エラーが発生しました。もう一度お試しください。',
  }
};
